import React, { useEffect } from "react";
import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import TimePicker from "@/common/elements/TimePicker";
import dayjs from "dayjs";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import {
  getRefListNameByID,
} from "@/util/common_function";

const ClientParamsForm = ({
  form,
  initialValues = {},
  onFinish,
  disabled = false,
}) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  useEffect(() => {
    if (initialValues) form.setFieldsValue({
      clientParamID: initialValues.clientParamID,
      paramName: initialValues.paramName,
      paramContext: initialValues.paramContext,
      paramValue: initialValues.paramValue,
      id: initialValues.clientParamID,
      dateAdded: initialValues.dateAdded
        ? dayjs(initialValues.dateAdded)
        : dayjs(),
      timeAdded: initialValues.timeAdded
        ? dayjs(initialValues.timeAdded, "HH:mm")
        : dayjs(),
      user: initialValues.user || getRefListNameByID("", userDetails?.staffId, true, false),
    });
  }, [initialValues, form]);

  return (
    <Form form={form} onFinish={onFinish} layout="vertical" disabled={disabled}>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={12}>
        <FormItem name="clientParamID" hidden>
       <TextField disabled hidden />
     </FormItem>
          <FormItem name="paramName" label="Param Name" rules={[{ required: true, message: "Param Name is required!" }]}>
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={12}>
          <FormItem name="paramContext" label="Param Context" rules={[{ required: true, message: "Param Context is required!" }]}>
            <TextField />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24}>
          <FormItem name="paramValue" label="Param Value">
            <TextField />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>

      <StyledSectionHeading marginTop="20px">
        <span>Administrative Information</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={2}>
          <FormItem name="id" label="Id">
            <TextField disabled />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="dateAdded" label="Date Entered">
            <CommonDatePicker disabled />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="timeAdded" label="Time Entered">
            <TimePicker disabled />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="user" label="User">
            <TextField disabled />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
};

export default ClientParamsForm;
